/**
 * @file commin-mutations
 */
import topicFilterMutations from './topicFilter';

export default {
    ...topicFilterMutations
};
